import { IconProps } from "../../../types/style";

const CalendarCheck = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 1V2.5"
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 1V2.5"
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1.75 4.54492H10.25"
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11 9.5C11 9.875 10.895 10.23 10.71 10.53C10.365 11.11 9.73 11.5 9 11.5C8.495 11.5 8.035 11.315 7.685 11C7.53 10.87 7.395 10.71 7.29 10.53C7.105 10.23 7 9.875 7 9.5C7 8.395 7.895 7.5 9 7.5C9.6 7.5 10.135 7.76499 10.5 8.17999C10.81 8.53499 11 8.995 11 9.5Z"
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.21997 9.49977L8.71497 9.99477L9.77997 9.00977"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.5 4.25V8.17999C10.135 7.76499 9.6 7.5 9 7.5C7.895 7.5 7 8.395 7 9.5C7 9.875 7.105 10.23 7.29 10.53C7.395 10.71 7.53 10.87 7.685 11H4C2.25 11 1.5 10 1.5 8.5V4.25C1.5 2.75 2.25 1.75 4 1.75H8C9.75 1.75 10.5 2.75 10.5 4.25Z"
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.99774 6.8501H6.00223"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.14716 6.8501H4.15165"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.14716 8.3501H4.15165"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default CalendarCheck;
